import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { auth } from "./firebase/Firebase";
import Landing from "./Components/Landing";
import Home from "./Components/Home";
import Login from "./Components/Login";
import Profile from "./Components/Profile";
import Main from "./Components/Main";

// import "primereact/resources/themes/lara-light-cyan/theme.css";

// import "primereact/resources/themes/lara-light-teal/theme.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Tasks from "./Components/Tasks";
import QrCode from "./Components/QrCode";
import PdfMerge from "./Components/PdfMerge";

function App() {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
        setUser(user);
      } else {
        localStorage.removeItem("user");
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/landing" element={<Landing />} />
        <Route
          path="/home"
          element={user ? <Home /> : <Navigate to="/login" />}
        />
        <Route
          path="/main"
          element={user ? <Main /> : <Navigate to="/login" />}
        />
        <Route
          path="/profile"
          element={user ? <Profile /> : <Navigate to="/login" />}
        />
        <Route
          path="/tasks"
          element={user ? <Tasks /> : <Navigate to="/login" />}
        />
        <Route
          path="/qrcode"
          element={user ? <QrCode /> : <Navigate to="/login" />}
        />
        <Route
          path="/pdfmerge"
          element={user ? <PdfMerge /> : <Navigate to="/login" />}
        />

        <Route
          path="/login"
          element={!user ? <Login /> : <Navigate to="/home" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
